// extracted by mini-css-extract-plugin
export default {"content":"AboutPage_content__CUDSi","about":"AboutPage_about__W3Go4","block":"AboutPage_block__HBfNh"};